import { render, staticRenderFns } from "./ComponentProject.vue?vue&type=template&id=63b00d71&scoped=true&lang=html"
import script from "./ComponentProject.vue?vue&type=script&lang=js"
export * from "./ComponentProject.vue?vue&type=script&lang=js"
import style0 from "./ComponentProject.vue?vue&type=style&index=0&id=63b00d71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b00d71",
  null
  
)

export default component.exports